import React from 'react';

const ModalConfirmarEstado = ({
  show,
  onClose,
  onConfirm,
  cita,
  nuevoEstado,
  loading = false
}) => {
  if (!show || !cita) return null;

  const estadoInfo = {
    confirmada: { color: '#10b981', icono: '✅', texto: 'Confirmar' },
    completada: { color: '#3b82f6', icono: '✓', texto: 'Marcar como completada' },
    no_asistio: { color: '#ef4444', icono: '✕', texto: 'Marcar como no asistió' },
    cancelada: { color: '#f97316', icono: '❌', texto: 'Cancelar' },
    pendiente_pago: { color: '#f59e0b', icono: '💳', texto: 'Pendiente de pago' }
  };

  const info = estadoInfo[nuevoEstado] || { color: '#6b7280', icono: '?', texto: 'Cambiar estado' };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '420px', borderRadius: '16px', overflow: 'hidden' }}
      >
        <div style={{
          background: `linear-gradient(135deg, ${info.color} 0%, ${info.color}dd 100%)`,
          padding: '1.25rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span style={{ fontSize: '1.4rem' }}>{info.icono}</span>
            <h3 style={{ margin: 0, color: 'white', fontSize: '1.1rem', fontWeight: '700' }}>
              {info.texto}
            </h3>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div style={{
            padding: '1rem',
            backgroundColor: '#f9fafb',
            borderRadius: '8px',
            marginBottom: '1.5rem',
            border: `1px solid ${info.color}33`
          }}>
            <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#6b7280' }}>
              Cita actual
            </p>
            <p style={{ margin: 0, fontWeight: '600', color: '#374151' }}>
              {cita.cliente_nombre || 'Cliente'}
            </p>
            <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem', color: '#6b7280' }}>
              {new Date(cita.fecha_cita).toLocaleDateString('es-ES')} a las {cita.hora_inicio}
            </p>
          </div>

          <p style={{ color: '#374151', margin: '0 0 1.5rem 0' }}>
            ¿Confirmas cambiar el estado a <strong>{info.texto.toLowerCase()}</strong>?
          </p>

          <div className="modal-footer">
            <button
              onClick={onClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              style={{
                backgroundColor: info.color,
                color: 'white',
                border: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              disabled={loading}
              onMouseOver={(e) => e.target.style.opacity = '0.8'}
              onMouseOut={(e) => e.target.style.opacity = '1'}
            >
              {loading ? 'Actualizando...' : 'Confirmar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmarEstado;
